/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { readTarget } from "cms/documents/document/helpers";

const DocumentStyleSimpleNoSize = (props) => {
    
    const { document, options } = props || {};
    const targetData = readTarget(options);
    const { target } = targetData || {};

    return (
        <Fragment>
            {document ? (
                <a className='document-display-link' href={document.url} target={target}>
                    <div className='document-display-text'>
                        <div>{document.title}</div>
                    </div>
                </a>
            ) : null}
        </Fragment>
    );
};

export { DocumentStyleSimpleNoSize };
